import React from 'react'
import classNames from 'classnames'
import Logo from '../../assets/images/new-logo.png'
import classes from './Loading.module.css'

function Loading({ inline, compact, className = '', ...props }) {
    return (
        <div
            className={classNames(
                classes.loadingWrapper,
                inline && classes.inline,
                compact && classes.compact,
                className
            )}
            {...props}
        >
            <img src={Logo} className={classes.loadingLogo} />
        </div>
    )
}

export default Loading
